import { Box, Card, CardContent, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../config/axiosConfig';

const VerifyCertificate = () => {
  const { certificateId } = useParams();
  const [certificate, setCertificate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await api.get(`/verify/${certificateId}`);
        setCertificate(response.data);
      } catch (err) {
        setError('Certificat non trouvé ou invalide');
      }
    };
    fetchCertificate();
  }, [certificateId]);

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (!certificate) {
    return <Typography>Chargement...</Typography>;
  }

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', my: 4 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Vérification du Certificat
          </Typography>
          <Typography>Statut : {certificate.valid ? 'Valide' : 'Invalide'}</Typography>
          <Typography>Utilisateur : {certificate.user.nom} {certificate.user.prenom}</Typography>
          <Typography>Parcours : {certificate.parcours.nom}</Typography>
          <Typography>Date de délivrance : {new Date(certificate.issuedAt).toLocaleDateString('fr-FR')}</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VerifyCertificate;